import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

export const Progress = withStyles(theme => ({
  root: {
    position: "fixed",
    left: "50%",
    marginLeft: "-15px",
    top: "50%",
    marginTop: "-15px",
    color: "grey"
  }
}))(CircularProgress);
